import { createNamespacedHelpers } from 'vuex';
import {
  SETTINGS,
  TOGGLE_LOCALE,
  LOGIN,
  LOGOUT,
  SET_COLOR,
  SAVE_SETTINGS,
  LOAD_QR_TELEGRAM,
  ACTIVATE_CHANGE_PASSWORD,
  CHANGE_PASSWORD,
  SET_SHOWCODES,
  SET_MODALITA_ESTESA,
  SNACKBAR,
  SET_SHOWCONCORDATI,
} from '@/store/types';

const {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} = createNamespacedHelpers('Session');

export default {
  methods: {
    ...mapActions({
      login: LOGIN,
      loadSettings: SETTINGS,
      saveSettings: SAVE_SETTINGS,
      loadQrTelegram: LOAD_QR_TELEGRAM,
      activateChangePassword: ACTIVATE_CHANGE_PASSWORD,
      changePassword: CHANGE_PASSWORD,
      authModalitaEstesa: SET_MODALITA_ESTESA,
      logout: LOGOUT,
    }),
    ...mapMutations({
      toggleLocale: TOGGLE_LOCALE,
      setColor: SET_COLOR,
      setShowCodes: SET_SHOWCODES,
      setShowConcordati: SET_SHOWCONCORDATI,
      setModalitaEstesa: SET_MODALITA_ESTESA,
      setSnackbar: SNACKBAR,
    }),
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'settings',
      'localiAttivi',
      'locali',
      'settingsLoaded',
      'colors',
      'coloreLocale',
      'descrLocale',
      'moduli',
      'mostraCodiciArticolo',
      'mostraConcordati',
      'modalitaEstesa',
      'modalita',
      'multiMode',
    ]),
    ...mapState([
      'snackbar',
    ]),
  },
};
